import React from "react";
import { useState } from "react";
import { connect } from "react-redux";
import CurrencyFormatter from "currency-formatter";
import { updateHDEAnalysis } from "../../../../store/modules/qualityOfEarnings/actions";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { rowStyle } from "../../../Dashboard/customStyles";
import BVAInput from "../../../../components/BVAInput/BVAInput";
import FinancialHandler from "../../../../handlers/FinancialHandler";
import YearBar from "../YearBar";
import Subtitle from "../Subtitle";
import Item from "./Item";

function Matrix({
  currentCompanyHDEAnalysis,
  dispatchUpdateHDEAnalysis,
  labelTitle,
}) {
  const label = labelTitle.replace(/[ &-]/g, ""); //Must get rid of spaces to get variables by names
  
  const handleChange = (label, value, id, type, key = "") => {
    dispatchUpdateHDEAnalysis(label, value, id, type, key);
  };

  const handleOnClickGPT = async () => {
    if(currentCompanyHDEAnalysis["matrix" + label]?.matrix?.length > 1) {
      handleChange(label, "Generating...", 0, "note");
      let other = labelTitle === "Ownership Salary" ? {
        socialSecirutyTax: currentCompanyHDEAnalysis.totalSocialSecurityTaxes,
        medicareTax: currentCompanyHDEAnalysis.totalMedicareTaxes,
        grandTotal: currentCompanyHDEAnalysis.totalOwnershipSalaryandPayrollTaxes,
      } : {};
      const note = await FinancialHandler.fetchGPTHDENoteGeneration(
        labelTitle,
        currentCompanyHDEAnalysis.yearsFormatted,
        currentCompanyHDEAnalysis.totalSalesRevenue,
        currentCompanyHDEAnalysis.totalEBITDAasDefined,
        currentCompanyHDEAnalysis["matrix" + label]?.matrix,
        currentCompanyHDEAnalysis["total" + label],
        other
      );
      handleChange(label, note, 0, "note");
    }
    else handleChange(label, "Please provide enough data", 0, "note");
  }

  return (
    <div className="overflow-none pb-10">

      <Subtitle title={labelTitle} />

      <YearBar pre="Items" after="Comments" data={currentCompanyHDEAnalysis?.yearsFormatted} />

      {/* input matrix */}
      {currentCompanyHDEAnalysis.percentage ?
        currentCompanyHDEAnalysis["matrix" + label]?.matrix?.filter((obj) => obj.name !== "")?.map((item) => (
          <div className={"flex items-center mt-5"}>
            <div className="whitespace-nowrap flex items-center" style={{ minWidth: "18em" }}>
              {item.name}
            </div>
            <div className="flex">
              {item.series.map((price, index) => (
                <div className="flex" style={{ width: "10em" }}>
                  <div style={{ minWidth: "1.3em" }} />
                  {CurrencyFormatter.format(price?.value * 100 / currentCompanyHDEAnalysis.totalSalesRevenue[index].value, { code: "" })}
                  {"%"}
                </div>
              ))}
            </div>
            <div className="whitespace-nowrap flex items-center px-6" style={{ minWidth: "25em" }}>
              {item.comment}
            </div>
          </div>
        ))
        :
        currentCompanyHDEAnalysis["matrix" + label]?.matrix?.map((item) => (
          <div className="flex items-center mt-1">
            <div className="flex" style={{ minWidth: "18em" }}>
              <TextareaAutosize
                style={rowStyle.tableItems}
                aria-label="minimum height"
                minRows={1}
                maxRows={1}
                defaultValue={item.name}
                onBlur={(e) => handleChange(label, e.target.value, item.id, "name")}
              />
            </div>
            <div className="flex">
              {item.series.map((price) => (
                <div className="flex items-center" style={{ width: "10em" }}>
                  <BVAInput
                    startAdornment
                    startAdornmentLabel="$ "
                    width="95%"
                    size="small"
                    key={price.date}
                    value={price.value}
                    onChange={(value) => handleChange(label, value, item.id, "series", price.date)}
                  />
                </div>
              ))}
            </div>
            <div className="flex" style={{ minWidth: "25em" }}>
              <TextareaAutosize
                style={rowStyle.tableComments}
                aria-label="minimum height"
                minRows={1}
                maxRows={1}
                defaultValue={item.comment}
                onBlur={(e) => handleChange(label, e.target.value, item.id, "comment")}
              />
            </div>
          </div>
        ))
      }

      <Item name={"Total " + labelTitle} bold={true} />

      {/* We need taxes when it is Ownership Salary */}
      {labelTitle === "Ownership Salary" ? 
        (<div>
          <Item name="Social Security Taxes" />
          <Item name="Medicare Taxes" />
          <Item name="Ownership Salary and Payroll Taxes" bold={true} />
        </div>)
        :
        (<div />)
      }

      {/* Analyst note */}
      <div className="data-bottom pt-5">
        <h5 className="noteHead">Analyst Note&nbsp;&nbsp;&nbsp;<button onClick={() => handleOnClickGPT()}>🤖</button></h5>
        <textarea
          className="analystNote px-3 py-1"
          style={{ width: currentCompanyHDEAnalysis?.yearsFormatted?.length * 10 + 43 + "em" }}
          rows={3}
          value={currentCompanyHDEAnalysis["matrix" + label]?.note}
          onChange={(e) => handleChange(label, e.target.value, 0, "note")}
        />
      </div>

    </div>
  );
}

const mapStateToProps = (state) => ({
  currentCompanyHDEAnalysis: state.qualityOfEarnings.currentCompanyHDEAnalysis,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchUpdateHDEAnalysis(label, value, id, type, key) {
    dispatch(updateHDEAnalysis(label, value, id, type, key));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Matrix);
